exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-select[data-v-3bb9c756] .v-input__slot {\n  background-color: #dfe3ee !important;\n}\n", ""]);

// exports
